import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

const PREFILL_PARAMS = ["start_date", "end_date"]

// When visiting a bank account's statements with ?open_modal=fetch_statement (from the
// accounting export's statements row), loads "Stiahnuť z banky" into bank_statement_fetch_modal,
// prefilled with the start_date/end_date the link carried.
export default class extends Controller {
  static values = {
    fetchUrl: String
  }

  connect() {
    const params = new URLSearchParams(window.location.search)
    if (params.get("open_modal") !== "fetch_statement" || !this.fetchUrlValue) {
      return
    }

    const url = new URL(this.fetchUrlValue, window.location.origin)
    for (const name of PREFILL_PARAMS) {
      if (params.get(name)) url.searchParams.set(name, params.get(name))
    }

    this.cleanUrl()
    Turbo.visit(url.pathname + url.search, { frame: "bank_statement_fetch_modal" })
  }

  cleanUrl() {
    const url = new URL(window.location.href)
    for (const name of ["open_modal", ...PREFILL_PARAMS]) url.searchParams.delete(name)
    const clean = url.pathname + (url.search ? url.search : "") + url.hash
    window.history.replaceState(window.history.state, "", clean)
  }
}
